import React, { useEffect, useState } from 'react'
import { list, badgeDataByID, deleteBadgeByCId } from '../api/company';
import Loader from '../components/Loader';

import { setCallBackURL } from "../api/company"
import { useNavigate, } from 'react-router-dom';
import useUserStore from '../store/useUserStore';
import PopupModal from '../components/PopupModal';
import { extractBadgeDetails } from '../utils/badgeFormatter';


export default function Badge() {

    const { user } = useUserStore();
    const [showPopup, setShowPopup] = useState(false);
    const [popUpMessage, setPopUpMessage] = useState({ "title": "", "text": "" })
    const [onConfirmAction, setOnConfirmAction] = useState(null);
    const [loading, setLoading] = useState(false);

    const [companyName, setCompanyName] = useState("0");


    const [badgeList, setBadgeList] = useState([]);
    const [apiError, setApiError] = useState('');
    const [errorStatus, setErrorStatus] = useState("success");
    const navigate = useNavigate();
    const [option, setOption] = useState([{
        "id": "",
        "companyName": "Please select company"
    }]);
    const getCompanyList = async () => {
        setLoading(true);
        let data = await list(user.db);
        setLoading(false);
        if (data.status > 199 && data.status <= 399) {
            setOption([{ id: 0, companyName: "Please select company" },
            ...data.data.data.map(obj => ({
                ...obj,
                companyName: `${obj.companyName} (${obj?.clientID || obj?.email || ""})`,
                status: obj.status || 'Active' // If status doesn't exist or is falsy, set it to 'Active'
            })).sort((a, b) =>
                a.companyName.localeCompare(b.companyName, undefined, { sensitivity: "base" })
            )
            ]);
        }
    }
    const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
    useEffect(() => {
        getCompanyList();
    }, []);

    useEffect(() => {
        const run = async () => {
            await delay(5000);
            setApiError("");
        };
        run();
    }, [apiError]);


    const getData = async (value) => {
        setLoading(true);
        const badgeRes = await badgeDataByID(value);
        setLoading(false);
        if (badgeRes.status > 199 && badgeRes.status < 400) {
            setBadgeList(extractBadgeDetails(badgeRes.data.data[0]?.Badges || {}))
        } else {
            setBadgeList([])
        }
    }

    const handleCompanyChange = async (e) => {
        const { value, } = e.target;
        setCompanyName(value);
        const result = option.find(c => c._id === value);
        getData(value);
    }

    const HandleAddBadgeBtnClick = () => {
        const result = option.find(c => c._id === companyName);
        navigate(`/badge/add/${companyName}`)
    }
    const HandleEdit = (obj) => {
        console.log("obj", obj);
        navigate(`/badge/edit/${companyName}/${obj.Main}`)
    }
    const handleDelete = async (obj) => {

        let deleteRes = await deleteBadgeByCId({ "cID": companyName, "Badge": obj.Main })
        setOnConfirmAction(null);
        setPopUpMessage({
            title: "Success",
            text: deleteRes.data.message,
            cancelLabel: "Close"
        });
        setShowPopup(true);
        const result = option.find(c => c._id === companyName);
        getData(companyName);
    }
    const HandleDeleteBadgeBtnClick = (obj) => {
        setPopUpMessage({
            title: "Delete Confirmation",
            text: "Are you sure you want to delete this item?",
            confirmLabel: "Yes, Delete",
            cancelLabel: "Cancel"
        });

        setOnConfirmAction(() => () => {
            handleDelete(obj);          // Your custom delete logic
            setShowPopup(false);     // Close modal after action
        });

        setShowPopup(true);
    }

    const [callbackInput, setCallbackInput] = useState({ userName: '', password: '' });
    const [showCallbackInput, setShowCallbackInput] = useState(false);
    const [callbackObj, setCallbackObj] = useState(null);

    // Handler for Set Callback URL
    const handleSetCallback = (obj) => {
        if (obj.userName && obj.password) {
            // Both present, call API directly
            callSetCallbackAPI(obj, obj.userName, obj.password);
        } else {
            // Show popup to collect userName and password
            setCallbackInput({ userName: obj.userName || '', password: obj.password || '' });
            setCallbackObj(obj);
            setShowCallbackInput(true);
        }
    };

    // Call API for Set Callback URL
    const callSetCallbackAPI = async (obj, userName, password) => {
        console.log("obj", obj);
        setLoading(true);
        try {
            const payload = { ...obj, userName, password, cID: obj.mainID };
            const res = await setCallBackURL(payload);
            setLoading(false);
            getData(companyName);
            setPopUpMessage({
                title: res.status > 199 && res.status < 400 ? 'Success' : 'Error',
                text: (res.status >= 400) ? res.response.data.message : res?.message || 'Callback URL set.',
                cancelLabel: 'Close',
            });
            setShowPopup(true);
        } catch (err) {
            setLoading(false);
            setPopUpMessage({
                title: 'Error',
                text: err?.data?.message || 'Failed to set callback URL.',
                cancelLabel: 'Close',
            });
            setShowPopup(true);
        }
    };

    // Handler for confirming callback input
    const handleCallbackConfirm = () => {
        if (!callbackInput.userName || !callbackInput.password) {
            setPopUpMessage({
                title: 'Error',
                text: 'User Name and Password are required.',
                cancelLabel: 'Close',
            });
            setShowPopup(true);
            // Do NOT close the callback input popup here
            return;
        }
        // Do NOT close the callback input popup here, let the user close it manually if needed
        callSetCallbackAPI(callbackObj, callbackInput.userName, callbackInput.password);
    };

    return (
        <>
            {loading && <Loader />}
            <PopupModal
                isOpen={showPopup}
                data={popUpMessage}
                onClose={() => {
                    setShowPopup(false)
                    setPopUpMessage({
                        "title": "",
                        "text": ""
                    })
                }}
                onConfirm={onConfirmAction}
                zIndex={1100}
            />
            {/* Popup for Set Callback URL input */}
            <PopupModal
                isOpen={showCallbackInput}
                data={{ title: 'Set Callback URL', text: '' }}
                onClose={() => setShowCallbackInput(false)}
                onConfirm={handleCallbackConfirm}
                confirmLabel="Set Callback"
                cancelLabel="Cancel"
                zIndex={1000}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    <label>
                        User Name:
                        <input
                            type="text"
                            value={callbackInput.userName}
                            onChange={e => setCallbackInput({ ...callbackInput, userName: e.target.value })}
                            className="form-control"
                        />
                    </label>
                    <label>
                        Password:
                        <input
                            type="password"
                            value={callbackInput.password}
                            onChange={e => setCallbackInput({ ...callbackInput, password: e.target.value })}
                            className="form-control"
                        />
                    </label>
                </div>
            </PopupModal>
            <div className="content-wrapper">
                {apiError && <div className={`alert alert-${errorStatus} mb-4`}> {apiError}</div>}


                <div className="page-header">
                    <div className="form-group col-lg-4">
                        <label htmlFor="exampleSelectGender">Select Company</label>
                        <select className="form-select" id="exampleSelectGender" name="companyName" value={companyName} onChange={handleCompanyChange}>
                            {option
                                .filter((obj) => obj.id !== "")
                                .map((obj) => (
                                    <option key={obj.id} value={obj.id} >
                                        {obj.companyName}
                                    </option>
                                ))}
                        </select>
                    </div>
                    {apiError && <div className={`alert alert-${errorStatus} mb-4`}> {apiError}</div>}

                    {companyName !== "0" &&
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <button type="button" onClick={HandleAddBadgeBtnClick} className="btn btn-primary me-2">Add Badge </button>

                            </ol>
                        </nav>
                    }

                </div>


                <div className="col-lg-12 grid-margin stretch-card">
                    <div className="card">
                        <div className="card-body">
                            <h4 className="card-title">Badge List</h4>
                            <div className="table-responsive ">
                                <table className="table table-bordered table-hover">
                                    <thead>
                                        <tr>
                                            <th> # </th>
                                            <th> Type </th>
                                            <th> Client </th>
                                            <th> Office </th>
                                            <th> Badge </th>
                                            <th> Topic </th>
                                            <th> User Name </th>
                                            <th> Password </th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {badgeList.map((obj, index) => (
                                            <tr key={obj._id}>
                                                <td> {index + 1} </td>
                                                <td> {obj.Main} </td>
                                                <td> {obj.ClientID} </td>
                                                <td> {obj.Office} </td>
                                                <td> {obj.Badge} </td>
                                                <td> {obj.topic} </td>
                                                <td> {obj.userName} </td>
                                                <td> {obj.password} </td>
                                                <td>
                                                    <button style={{ marginLeft: "10px" }} type="button" onClick={() => HandleEdit(obj)} className="btn btn-success me-2" >Edit</button>
                                                    <button type="button" onClick={() => HandleDeleteBadgeBtnClick(obj)} className="btn btn-danger me-2">Delete </button>
                                                    <button type="button" onClick={() => handleSetCallback(obj)} className="btn btn-primary me-2">Set Callback </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
